import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../components/Pagination";

import moment from "moment";

const CustomerUpload = () => {
  const [data, setData] = useState([]);
  const now = new Date();
  const[employeeData,setEmployeeData]=useState([]);

 
  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => { 
        setEmployeeData(data.data);
 
      }
    );
  }, [getEmp]);

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng:"",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        // //console.log(lat, long);
        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const [formData, setFormData] = useState();

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    return uniqueID.toString();
  }
  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });
  
  
    const headers = parsedData[0];

    var customerId =generateUniqueID()
    var addressId =customerId;
    var  customerBankId=customerId;
    const jsonData = parsedData?.slice(1).map((row) => {
      
      const fieldExecutiveEmailIndex = headers.indexOf("Field Executive Email");
      let fieldExecutiveEmail = "";
      if (fieldExecutiveEmailIndex !== -1 && row[fieldExecutiveEmailIndex]) {
        fieldExecutiveEmail = row[fieldExecutiveEmailIndex].trim();
      }
      const employeelist = employeeData.filter(
        (employee) => (employee.emailId ?? "") === fieldExecutiveEmail
      );
      const fieldExecutiveId = employeelist.length > 0 ? employeelist[0].userId : 0;
      customerId= parseInt(customerId)+1;
      customerBankId=parseInt(customerBankId)+1;
      addressId=parseInt(addressId)+2;

      const customer = {
        customerId: customerId,
        orgId: localStorage.getItem("orgId"),
        fieldExecutiveId,
        name: row[headers.indexOf("Customer Name")],
        emailId: row[headers.indexOf("Customer Email Id")],
        idProof: row[headers.indexOf("ID Proof")],
        fileAttachment: row[headers.indexOf("Attachment Url")],
        paymentTermsInDays: row[headers.indexOf("Payment Terms in Days")],
        workContactNumber: row[headers.indexOf("Contact Number")],
        createdBy: fieldExecutiveId,
        status: 1,
        regionId: 2,
        createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
        entryTime: moment().format("HH:mm:ss"),
        entryLatLong,
        customerAddressDetails: [
          {
            srno: 1,
            customerAddressId: addressId,
            addressType: "Registered",
            address: row[headers.indexOf("Registered Address")],
            city: row[headers.indexOf("Registered City")],
            state: row[headers.indexOf("Registered State")],
            zipCode: row[headers.indexOf("Registered Zip Code")],
            country: row[headers.indexOf("Registered Country")],
            latLong: {
              latitude: row[headers.indexOf("Registered Lat")],
              longitude: row[headers.indexOf("Registered Long")],
            },
            orgId: parseInt(localStorage.getItem("orgId")),
            createdBy: fieldExecutiveId,
            status: 1,
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
            entryTime: moment().format("HH:mm:ss"),
            entryLatLong,
          },
          {
            srno: 2,
            customerAddressId: parseInt(addressId)+1,
            addressType: "Billing",
            address: row[headers.indexOf("Billing Address")],
            city: row[headers.indexOf("Billing City")],
            state: row[headers.indexOf("Billing State")],
            zipCode: row[headers.indexOf("Billing Zip Code")],
            country: row[headers.indexOf("Billing Country")],
            latLong: {
              latitude: row[headers.indexOf("Billing Lat")],
              longitude: row[headers.indexOf("Billing Long")],
            },
            orgId: parseInt(localStorage.getItem("orgId")),
            createdBy: fieldExecutiveId,
            status: 1,
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
            entryTime: moment().format("HH:mm:ss"),
            entryLatLong,
          },
        ],
        bankDetails: [
          {
            srno: 1,
            accountNumber: row[headers.indexOf("Account Number")],
            accountHolderName: row[headers.indexOf("Acc Holder Name")],
            ifscCode: row[headers.indexOf("IFSC Code")],
            customerBankId: customerBankId,
            orgId: parseInt(localStorage.getItem("orgId")),
            createdBy: fieldExecutiveId,
            status: 1,
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
            entryTime: moment().format("HH:mm:ss"),
            entryLatLong,
          },
        ],
        contactPersonDetails: [
          {
            srno: 1,
            customerContactPersonId: customerId,
            name: row[headers.indexOf("Contact Person Name")],
            designation: row[headers.indexOf("Contact Person Designation")],
            workContactNumber: row[headers.indexOf("Contact Person Contact Number")],
            whatsappContactNumber: row[headers.indexOf("Contact Person Whatsapp Number")],
            emailId: row[headers.indexOf("Contact Person Email Id")],
            orgId: parseInt(localStorage.getItem("orgId")),
            createdBy: fieldExecutiveId,
            status: 1,
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
            entryTime: moment().format("HH:mm:ss"),
            entryLatLong,
          },
        ],

       
      };

      return customer;
    });

 

    setData(parsedData);
    setFormData(jsonData);
    console.log(jsonData);
   
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: postCustomer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postCustomer(
      {
        url: "/api/uploadCustomerView/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Customer Added  Successfully`);
        setFormData("");
        setData("");
      }
    );
  };
  return (
    <>
      {" "}
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                      <div className="col-10">
                        <label className="card-title mx-2 my-3 ">
                          Customer Details
                        </label>
                        </div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered table-responsive text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {currentItems[0] &&
                                currentItems[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems &&
                              currentItems.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button className="btn  btn-primary mx-2 my-2" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CustomerUpload;
